import styled from 'styled-components';
import {
  mq,
  px2rem,
  getSpace,
  gridContainer,
  setGridColumns,
  getGridColumns
} from '../../../stylesheets/tools';

const StyledTeaserContainerShaped = styled.section`
  .container__wrapper {
    padding: ${getSpace('xxl')} 0;
  }
  .teasers__headline {
    margin-bottom: ${getSpace('xl')};

    ${mq('m')} {
      margin-bottom: ${getSpace('l')};
    }
    ${mq('xl')} {
      margin-bottom: ${getSpace('s')};
    }
  }
  .teasers__grid {
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    gap: 50px;

    ${mq('l')} {
      gap: 20px;
      padding-top: ${getSpace('xxxl')};
      ${setGridColumns('1fr', 3)}
    }

    ${mq('xl')} {
      gap: 40px;
    }

    .teasers__grid-item {
      &.highlight-teaser {
        ${getGridColumns([1, 1], { l: [1, 4] })}

        ${mq('l')} {
          padding-bottom: ${px2rem('60px')};
        }
      }
    }
  }
`;
export default StyledTeaserContainerShaped;
